// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/ShadersInclude/lightFragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'lightFragment';
const shader = `#ifdef LIGHT{X}
#if defined(SHADOWONLY) || defined(LIGHTMAP) && defined(LIGHTMAPEXCLUDED{X}) && defined(LIGHTMAPNOSPECULAR{X})
#else
#ifdef PBR
#ifdef LINELIGHT{X}
vec3 horizonAdjustedLineA{X} = light{X}.vLineA;
vec3 horizonAdjustedLineB{X} = light{X}.vLineB;
vec3 positionToLineA{X} = light{X}.vLineA - vPositionW;
vec3 positionToLineB{X} = light{X}.vLineB - vPositionW;
vec3 lineAtoLineB{X} = light{X}.vLineB - light{X}.vLineA;
vec2 lineABRangeT{X} = vec2(0.0, 1.0);
if ((dot(positionToLineA{X}, normalW) > 0.0) != (dot(positionToLineB{X}, normalW) > 0.0))
{
float t = -dot(positionToLineA{X}, normalW) / dot(lineAtoLineB{X}, normalW);
vec3 intersectionPoint = light{X}.vLineA + t * lineAtoLineB{X};
if (dot(positionToLineA{X}, normalW) > 0.0)
{
horizonAdjustedLineB{X} = intersectionPoint;
lineABRangeT{X}.y = t;
}
else
{
horizonAdjustedLineA{X} = intersectionPoint;
lineABRangeT{X}.x = t;
}
}
#elif defined(SPOTLIGHT{X})
preInfo=computePointAndSpotPreLightingInfo(light{X}.vLightData, viewDirectionW, normalW);
#elif defined(POINTLIGHT{X})
preInfo = computePointAndSpotPreLightingInfo(light{X}.vLightData, viewDirectionW, normalW);
#elif defined(HEMILIGHT{X})
preInfo = computeHemisphericPreLightingInfo(light{X}.vLightData, viewDirectionW, normalW);
#elif defined(DIRLIGHT{X})
preInfo = computeDirectionalPreLightingInfo(light{X}.vLightData, viewDirectionW, normalW);
#endif
preInfo.NdotV = NdotV;
#ifdef SPOTLIGHT{X}
#ifdef LIGHT_FALLOFF_GLTF{X}
preInfo.attenuation = computeDistanceLightFalloff_GLTF(preInfo.lightDistanceSquared, light{X}.vLightFalloff.y);
preInfo.attenuation *= computeDirectionalLightFalloff_GLTF(light{X}.vLightDirection.xyz, preInfo.L, light{X}.vLightFalloff.z, light{X}.vLightFalloff.w);
#elif defined(LIGHT_FALLOFF_PHYSICAL{X})
preInfo.attenuation = computeDistanceLightFalloff_Physical(preInfo.lightDistanceSquared);
preInfo.attenuation *= computeDirectionalLightFalloff_Physical(light{X}.vLightDirection.xyz, preInfo.L, light{X}.vLightDirection.w);
#elif defined(LIGHT_FALLOFF_STANDARD{X})
preInfo.attenuation = computeDirectionalLightFalloff_GLTF(light{X}.vLightDirection.xyz, preInfo.L, light{X}.vLightFalloff.z, light{X}.vLightFalloff.w);
#else
preInfo.attenuation = computeDistanceLightFalloff(preInfo.lightOffset, preInfo.lightDistanceSquared, light{X}.vLightFalloff.x, light{X}.vLightFalloff.y);
preInfo.attenuation *= computeDirectionalLightFalloff(light{X}.vLightDirection.xyz, preInfo.L, light{X}.vLightDirection.w, light{X}.vLightData.w, light{X}.vLightFalloff.z, light{X}.vLightFalloff.w);
#endif
#elif defined(POINTLIGHT{X})
#ifdef LIGHT_FALLOFF_GLTF{X}
preInfo.attenuation = computeDistanceLightFalloff_GLTF(preInfo.lightDistanceSquared, light{X}.vLightFalloff.y);
#elif defined(LIGHT_FALLOFF_PHYSICAL{X})
preInfo.attenuation = computeDistanceLightFalloff_Physical(preInfo.lightDistanceSquared);
#elif defined(LIGHT_FALLOFF_STANDARD{X})
preInfo.attenuation = computeDistanceLightFalloff_Standard(preInfo.lightOffset, light{X}.vLightFalloff.x);
#else
preInfo.attenuation = computeDistanceLightFalloff(preInfo.lightOffset, preInfo.lightDistanceSquared, light{X}.vLightFalloff.x, light{X}.vLightFalloff.y);
#endif
#else
preInfo.attenuation = 1.0;
#endif
#ifdef HEMILIGHT{X}
preInfo.roughness = roughness;
#else
preInfo.roughness = adjustRoughnessFromLightProperties(roughness, light{X}.vLightSpecular.a, preInfo.lightDistance);
#endif
#ifdef IRIDESCENCE
preInfo.iridescenceIntensity = iridescenceIntensity;
#endif
#ifdef LINELIGHT{X}
vec3 lineDirection{X} = light{X}.vLineB - light{X}.vLineA;
float lineLength{X} = length(lineDirection{X});
lineDirection{X} /= lineLength{X};
float t{X} = dot(vPositionW - light{X}.vLineA, lineDirection{X}) / lineLength{X};
t{X} = clamp(t{X}, lineABRangeT{X}.x, lineABRangeT{X}.y);
vec3 lineLightPosition{X} = light{X}.vLineA + lineDirection{X} * lineLength{X} * t{X};
preInfo = computeLineLightDiffusePreLightingInfo(lineLightPosition{X}, normalW);
preInfo.NdotV = NdotV;
float cosHalfAngle{X} = light{X}.vLineNormalAndAngleRange.w;
#ifdef LIGHT_FALLOFF_GLTF{X}
preInfo.attenuation = computeDistanceLightFalloff_GLTF(preInfo.lightDistanceSquared, light{X}.vLightFalloff.y);
float cosHalfAngleInverseScale{X} = 1.0 / (1.0 - cosHalfAngle{X});
float lineLightIlluminance{X} = computeDirectionalLightFalloff_GLTF(light{X}.vLineNormalAndAngleRange.xyz, preInfo.L, cosHalfAngleInverseScale{X}, -cosHalfAngle{X} * cosHalfAngleInverseScale{X});
#else
preInfo.attenuation = computeDistanceLightFalloff_Physical(preInfo.lightDistanceSquared);
float lineLightIlluminance{X} = computeDirectionalLightFalloff_Physical(light{X}.vLineNormalAndAngleRange.xyz, preInfo.L, cosHalfAngle{X});
#endif
if (light{X}.vLightFalloff.z == 1.0 && (t{X} == 0.0 || t{X} == 1.0)) {
lineLightIlluminance{X} = 0.0;
}
float clipPlaneCutoff{X} = (dot(lineLightPosition{X}, light{X}.vLineClipPlaneNormalDistance.xyz) - light{X}.vLineClipPlaneNormalDistance.w) < dot(preInfo.lightOffset, light{X}.vLineClipPlaneNormalDistance.xyz) ? 0.0 : 1.0;
lineLightIlluminance{X} *= clipPlaneCutoff{X};
preInfo.attenuation *= lineLightIlluminance{X};
#endif
#ifdef HEMILIGHT{X}
info.diffuse = computeHemisphericDiffuseLighting(preInfo, light{X}.vLightDiffuse.rgb, light{X}.vLightGround);
#elif defined(SS_TRANSLUCENCY)
info.diffuse = computeDiffuseAndTransmittedLighting(preInfo, light{X}.vLightDiffuse.rgb, subSurfaceOut.transmittance);
#else
info.diffuse = computeDiffuseLighting(preInfo, light{X}.vLightDiffuse.rgb);
#endif
#ifdef SPECULARTERM
#ifdef LINELIGHT{X}
#ifdef LIGHT_FALLOFF_GLTF{X}
float preAttenuation{X} = lineLightIlluminance{X} * computeDistanceLightFalloff_GLTF(preInfo.lightDistanceSquared, light{X}.vLightFalloff.y);
#else
float preAttenuation{X} = lineLightIlluminance{X} * computeDistanceLightFalloff_Physical(preInfo.lightDistanceSquared);
#endif
preInfo = computeLineLightSpecularPreLightingInfo(viewDirectionW, normalW, reflect(viewDirectionW, normalW), horizonAdjustedLineA{X}, horizonAdjustedLineB{X});
preInfo.roughness = adjustRoughnessFromLightProperties(roughness, light{X}.vLightSpecular.a, preInfo.lightDistance);
preInfo.NdotV = NdotV;
preInfo.attenuation = preAttenuation{X};
#endif
#ifdef ANISOTROPIC
info.specular = computeAnisotropicSpecularLighting(preInfo, viewDirectionW, normalW, anisotropicOut.anisotropicTangent, anisotropicOut.anisotropicBitangent, anisotropicOut.anisotropy, clearcoatOut.specularEnvironmentR0, specularEnvironmentR90, AARoughnessFactors.x, light{X}.vLightDiffuse.rgb);
#else
info.specular = computeSpecularLighting(preInfo, normalW, clearcoatOut.specularEnvironmentR0, specularEnvironmentR90, AARoughnessFactors.x, light{X}.vLightDiffuse.rgb);
#endif
#endif
#ifdef SHEEN
#ifdef SHEEN_LINKWITHALBEDO
preInfo.roughness = sheenOut.sheenIntensity;
#else
#ifdef HEMILIGHT{X}
preInfo.roughness = sheenOut.sheenRoughness;
#else
preInfo.roughness = adjustRoughnessFromLightProperties(sheenOut.sheenRoughness, light{X}.vLightSpecular.a, preInfo.lightDistance);
#endif
#endif
info.sheen = computeSheenLighting(preInfo, normalW, sheenOut.sheenColor, specularEnvironmentR90, AARoughnessFactors.x, light{X}.vLightDiffuse.rgb);
#endif
#ifdef CLEARCOAT
#ifdef HEMILIGHT{X}
preInfo.roughness = clearcoatOut.clearCoatRoughness;
#else
preInfo.roughness = adjustRoughnessFromLightProperties(clearcoatOut.clearCoatRoughness, light{X}.vLightSpecular.a, preInfo.lightDistance);
#endif
info.clearCoat = computeClearCoatLighting(preInfo, clearcoatOut.clearCoatNormalW, clearcoatOut.clearCoatAARoughnessFactors.x, clearcoatOut.clearCoatIntensity, light{X}.vLightDiffuse.rgb);
#ifdef CLEARCOAT_TINT
absorption = computeClearCoatLightingAbsorption(clearcoatOut.clearCoatNdotVRefract, preInfo.L, clearcoatOut.clearCoatNormalW, clearcoatOut.clearCoatColor, clearcoatOut.clearCoatThickness, clearcoatOut.clearCoatIntensity);
info.diffuse *= absorption;
#ifdef SPECULARTERM
info.specular *= absorption;
#endif
#endif
info.diffuse *= info.clearCoat.w;
#ifdef SPECULARTERM
info.specular *= info.clearCoat.w;
#endif
#ifdef SHEEN
info.sheen *= info.clearCoat.w;
#endif
#endif
#else
#ifdef SPOTLIGHT{X}
info = computeSpotLighting(viewDirectionW, normalW, light{X}.vLightData, light{X}.vLightDirection, light{X}.vLightDiffuse.rgb, light{X}.vLightSpecular.rgb, light{X}.vLightDiffuse.a, glossiness);
#elif defined(HEMILIGHT{X})
info = computeHemisphericLighting(viewDirectionW, normalW, light{X}.vLightData, light{X}.vLightDiffuse.rgb, light{X}.vLightSpecular.rgb, light{X}.vLightGround, glossiness);
#elif defined(POINTLIGHT{X}) || defined(DIRLIGHT{X})
info = computeLighting(viewDirectionW, normalW, light{X}.vLightData, light{X}.vLightDiffuse.rgb, light{X}.vLightSpecular.rgb, light{X}.vLightDiffuse.a, glossiness);
#endif
#endif
#ifdef PROJECTEDLIGHTTEXTURE{X}
info.diffuse *= computeProjectionTextureDiffuseLighting(projectionLightSampler{X}, textureProjectionMatrix{X});
#endif
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
for (int i = 0; i < SHADOWCSMNUM_CASCADES{X}; i++)
{
#ifdef SHADOWCSM_RIGHTHANDED{X}
diff{X} = viewFrustumZ{X}[i] + vPositionFromCamera{X}.z;
#else
diff{X} = viewFrustumZ{X}[i] - vPositionFromCamera{X}.z;
#endif
if (diff{X} >= 0.) {
index{X} = i;
break;
}
}
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
if (index{X} >= 0)
#endif
{
#if defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
shadow = computeShadowWithCSMPCF1(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], shadowSampler{X}, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow = computeShadowWithCSMPCF3(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], shadowSampler{X}, light{X}.shadowsInfo.yz, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#else
shadow = computeShadowWithCSMPCF5(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], shadowSampler{X}, light{X}.shadowsInfo.yz, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
shadow = computeShadowWithCSMPCSS16(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], depthSampler{X}, shadowSampler{X}, light{X}.shadowsInfo.y, light{X}.shadowsInfo.z, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w, lightSizeUVCorrection{X}[index{X}], depthCorrection{X}[index{X}], penumbraDarkness{X});
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow = computeShadowWithCSMPCSS32(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], depthSampler{X}, shadowSampler{X}, light{X}.shadowsInfo.y, light{X}.shadowsInfo.z, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w, lightSizeUVCorrection{X}[index{X}], depthCorrection{X}[index{X}], penumbraDarkness{X});
#else
shadow = computeShadowWithCSMPCSS64(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], depthSampler{X}, shadowSampler{X}, light{X}.shadowsInfo.y, light{X}.shadowsInfo.z, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w, lightSizeUVCorrection{X}[index{X}], depthCorrection{X}[index{X}], penumbraDarkness{X});
#endif
#else
shadow = computeShadowCSM(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], shadowSampler{X}, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#endif
#ifdef SHADOWCSMDEBUG{X}
shadowDebug{X} = vec3(shadow) * vCascadeColorsMultiplier{X}[index{X}];
#endif
#ifndef SHADOWCSMNOBLEND{X}
float frustumLength = frustumLengths{X}[index{X}];
float diffRatio = clamp(diff{X} / frustumLength, 0., 1.) * cascadeBlendFactor{X};
if (index{X} < (SHADOWCSMNUM_CASCADES{X} - 1) && diffRatio < 1.)
{
index{X} += 1;
float nextShadow = 0.;
#if defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
nextShadow = computeShadowWithCSMPCF1(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], shadowSampler{X}, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
nextShadow = computeShadowWithCSMPCF3(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], shadowSampler{X}, light{X}.shadowsInfo.yz, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#else
nextShadow = computeShadowWithCSMPCF5(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], shadowSampler{X}, light{X}.shadowsInfo.yz, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
nextShadow = computeShadowWithCSMPCSS16(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], depthSampler{X}, shadowSampler{X}, light{X}.shadowsInfo.y, light{X}.shadowsInfo.z, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w, lightSizeUVCorrection{X}[index{X}], depthCorrection{X}[index{X}], penumbraDarkness{X});
#elif defined(SHADOWMEDIUMQUALITY{X})
nextShadow = computeShadowWithCSMPCSS32(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], depthSampler{X}, shadowSampler{X}, light{X}.shadowsInfo.y, light{X}.shadowsInfo.z, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w, lightSizeUVCorrection{X}[index{X}], depthCorrection{X}[index{X}], penumbraDarkness{X});
#else
nextShadow = computeShadowWithCSMPCSS64(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], depthSampler{X}, shadowSampler{X}, light{X}.shadowsInfo.y, light{X}.shadowsInfo.z, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w, lightSizeUVCorrection{X}[index{X}], depthCorrection{X}[index{X}], penumbraDarkness{X});
#endif
#else
nextShadow = computeShadowCSM(float(index{X}), vPositionFromLight{X}[index{X}], vDepthMetric{X}[index{X}], shadowSampler{X}, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#endif
shadow = mix(nextShadow, shadow, diffRatio);
#ifdef SHADOWCSMDEBUG{X}
shadowDebug{X} = mix(vec3(nextShadow) * vCascadeColorsMultiplier{X}[index{X}], shadowDebug{X}, diffRatio);
#endif
}
#endif
}
#elif defined(SHADOWCLOSEESM{X})
#if defined(SHADOWCUBE{X})
shadow = computeShadowWithCloseESMCube(vPositionW, light{X}.vLightData.xyz, shadowSampler{X}, light{X}.shadowsInfo.x, light{X}.shadowsInfo.z, light{X}.depthValues);
#else
shadow = computeShadowWithCloseESM(vPositionFromLight{X}, vDepthMetric{X}, shadowSampler{X}, light{X}.shadowsInfo.x, light{X}.shadowsInfo.z, light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWESM{X})
#if defined(SHADOWCUBE{X})
shadow = computeShadowWithESMCube(vPositionW, light{X}.vLightData.xyz, shadowSampler{X}, light{X}.shadowsInfo.x, light{X}.shadowsInfo.z, light{X}.depthValues);
#else
shadow = computeShadowWithESM(vPositionFromLight{X}, vDepthMetric{X}, shadowSampler{X}, light{X}.shadowsInfo.x, light{X}.shadowsInfo.z, light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPOISSON{X})
#if defined(SHADOWCUBE{X})
shadow = computeShadowWithPoissonSamplingCube(vPositionW, light{X}.vLightData.xyz, shadowSampler{X}, light{X}.shadowsInfo.y, light{X}.shadowsInfo.x, light{X}.depthValues);
#else
shadow = computeShadowWithPoissonSampling(vPositionFromLight{X}, vDepthMetric{X}, shadowSampler{X}, light{X}.shadowsInfo.y, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
shadow = computeShadowWithPCF1(vPositionFromLight{X}, vDepthMetric{X}, shadowSampler{X}, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow = computeShadowWithPCF3(vPositionFromLight{X}, vDepthMetric{X}, shadowSampler{X}, light{X}.shadowsInfo.yz, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#else
shadow = computeShadowWithPCF5(vPositionFromLight{X}, vDepthMetric{X}, shadowSampler{X}, light{X}.shadowsInfo.yz, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
shadow = computeShadowWithPCSS16(vPositionFromLight{X}, vDepthMetric{X}, depthSampler{X}, shadowSampler{X}, light{X}.shadowsInfo.y, light{X}.shadowsInfo.z, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow = computeShadowWithPCSS32(vPositionFromLight{X}, vDepthMetric{X}, depthSampler{X}, shadowSampler{X}, light{X}.shadowsInfo.y, light{X}.shadowsInfo.z, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#else
shadow = computeShadowWithPCSS64(vPositionFromLight{X}, vDepthMetric{X}, depthSampler{X}, shadowSampler{X}, light{X}.shadowsInfo.y, light{X}.shadowsInfo.z, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#endif
#else
#if defined(SHADOWCUBE{X})
shadow = computeShadowCube(vPositionW, light{X}.vLightData.xyz, shadowSampler{X}, light{X}.shadowsInfo.x, light{X}.depthValues);
#else
shadow = computeShadow(vPositionFromLight{X}, vDepthMetric{X}, shadowSampler{X}, light{X}.shadowsInfo.x, light{X}.shadowsInfo.w);
#endif
#endif
#ifdef SHADOWONLY
#ifndef SHADOWINUSE
#define SHADOWINUSE
#endif
globalShadow += shadow;
shadowLightCount += 1.0;
#endif
#else
shadow = 1.;
#endif
aggShadow += shadow;
numLights += 1.0;
#ifndef SHADOWONLY
#ifdef CUSTOMUSERLIGHTING
diffuseBase += computeCustomDiffuseLighting(info, diffuseBase, shadow);
#ifdef SPECULARTERM
specularBase += computeCustomSpecularLighting(info, specularBase, shadow);
#endif
#elif defined(LIGHTMAP) && defined(LIGHTMAPEXCLUDED{X})
diffuseBase += lightmapColor.rgb * shadow;
#ifdef SPECULARTERM
#ifndef LIGHTMAPNOSPECULAR{X}
specularBase += info.specular * shadow * lightmapColor.rgb;
#endif
#endif
#ifdef CLEARCOAT
#ifndef LIGHTMAPNOSPECULAR{X}
clearCoatBase += info.clearCoat.rgb * shadow * lightmapColor.rgb;
#endif
#endif
#ifdef SHEEN
#ifndef LIGHTMAPNOSPECULAR{X}
sheenBase += info.sheen.rgb * shadow;
#endif
#endif
#else
#ifdef SHADOWCSMDEBUG{X}
diffuseBase += info.diffuse * shadowDebug{X};
#else
diffuseBase += info.diffuse * shadow;
#endif
#ifdef SPECULARTERM
specularBase += info.specular * shadow;
#endif
#ifdef CLEARCOAT
clearCoatBase += info.clearCoat.rgb * shadow;
#endif
#ifdef SHEEN
sheenBase += info.sheen.rgb * shadow;
#endif
#endif
#endif
#endif`;
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const lightFragment = { name, shader };
//# sourceMappingURL=lightFragment.js.map